<template>
  <div class="site-nav">
    <site-nav-item v-for="(item, index) in navList" :key="`nav-item-${index}`" :item="item" />
  </div>
</template>

<script>
import SiteNavItem from './SiteNavItem'
// utils
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    SiteNavItem
  },
  computed: {
    ...mapState({
      navList: state => state.nav
    })
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    ...mapActions({
      setNav: 'setNav'
    }),
    cleanNav (list) {
      const filtered = list.filter(item => item.label.toUpperCase() !== 'ГЛАВНАЯ' && item.menuItem.show === 1)
      return filtered.map(item => {
        const { href, label } = item
        const items = item.items.filter(subItem => subItem.menuItem.show === 1).map(subItem => {
          const { href, label } = subItem

          return {
            href,
            label
          }
        })

        return {
          href,
          label,
          items
        }
      })
    },
    fetchData () {
      this.$http.api.get('/news/frontend-news/menu')
        .then((response) => {
          this.setNav(this.cleanNav(response.data))
        }, (error) => {
          console.error(error)
        }).catch(() => null)
    }
  }
}
</script>

<style lang="scss" scoped>
.site-nav {
  @include font-size(13px);

  align-items: center;
  font-family: $font-family-arial;
  display: flex;
  height: $header-height;

  @include media-breakpoint-up(lg) {
    justify-content: space-between;
    width: 100%;
  }
}
</style>
